import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "default" }
const _hoisted_2 = { class: "selected" }
const _hoisted_3 = { class: "hover" }
const _hoisted_4 = { class: "disabled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tirscript-list-view-item", _ctx.currentClass()]),
    onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouseover && _ctx.mouseover(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseleave && _ctx.mouseleave(...args))),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.click(_ctx.item))),
    onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    onDragstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dragStart && _ctx.dragStart(...args))),
    onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dragDrop && _ctx.dragDrop(...args)), ["stop"])),
    onDragend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dragEnd && _ctx.dragEnd(...args)))
  }, [
    (_ctx.isDefault())
      ? _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 0 }, _ctx.item.Value)), () => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
        ])
      : _createCommentVNode("", true),
    (_ctx.isSelected())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.item.Selected)
            ? _renderSlot(_ctx.$slots, "selected", _normalizeProps(_mergeProps({ key: 0 }, _ctx.item.Value)), () => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
              ])
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isHover())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.hovered)
            ? _renderSlot(_ctx.$slots, "hover", _normalizeProps(_mergeProps({ key: 0 }, _ctx.item.Value)), () => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
              ])
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isDisabled())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_ctx.item.Disabled)
            ? _renderSlot(_ctx.$slots, "disabled", _normalizeProps(_mergeProps({ key: 0 }, _ctx.item.Value)), () => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1)
              ])
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 34))
}